// Texty promo pruhu — slovenské dvojča locale/cs/promoBar.js.
import { NBSP } from '../../modules/money.js';

export default {
  shipStrong: 'DOPRAVA ZADARMO',
  shipLead: ' na výdajné miesto',
  shipTail: ' pri nákupe',
  shipCta: 'Doplniť zásoby',
  saleStrong: 'ZĽAVOVÁ AKCIA',
  saleLead: ' práve prebieha',
  saleTail: ' – zľavnený tovar naprieč sortimentom',
  saleCta: 'Zobraziť zľavy',
  fastDay: { sat: 'V SOBOTU', sun: 'V PONDELOK' },
  fastStrong: 'DORUČÍME ',
  fastOrder: ' – objednajte ',
  fastSunday: ' – v nedeľu zvážame, objednajte ',
  fastWith: 's',
  close: 'Zavrieť oznámenie',
  over: (price) => ' nad ' + price + '.',
  bigger: ' pri väčšom nákupe.',
  promoStrong: (carrier, price) => carrier + ' ZA ' + price,
  promoLead: (maxKg) => ' na výdajné miesto do ' + maxKg + NBSP + 'kg',
  promoTail: (freeFrom, until) => ' – nad ' + freeFrom + ' zadarmo, akcia platí do ' + until.replace(/\.$/, ''),
};
